export const APPLICATION = "builder";
export const ENVIRONMENT = "prod";
export const BACKEND = "";
export const KEYCLOAK_JS_URL = "https://api-builder.gjgardner.com.au/auth/js/keycloak.js";
export const KEYCLOAK_JSON_URL = "";
export const KEYCLOAK_MIN_VALIDITY = 5;
export const KEYCLOAK_AUTH_SERVER_URL = "https://api-builder.gjgardner.com.au/auth";
export const KEYCLOAK_REALM = "GH-BPortal-AU";
export const KEYCLOAK_RESOURCE = "GH-BPortal-WebApp-AU";
export const KEYCLOAK_SECRET = "";
export const API_BASE_URL = "https://api-builder.gjgardner.com.au";
export const API_SB_URL = "api-sandbox-builder.gjgardner.com.au";
export const ENV_BASE_URL = "https://api-builder.gjgardner.com.au";
export const NODE_ENV = "production";
export const REGION_CODE = "au";
export const CONTEXT_PATH = "/";
export const VERSION = "5.4.56";
export const RELEASE = "builder@5.4.56";
export const APP_NAME = "Builder Portal";
export const DEFAULT_LOCALE = "en_AU";
export const LOCALES_CONTEXT_FILTER = /(en|en-AU|en-US|en-NZ)\.mjs$/;
export const DEFAULT_EMAIL_SUFFIX = "@gjgardner.com.au";
export const DEFAULT_COUNTRY_CODE = "61";
export const SCAYT_SERVICE_ID = "1:tLBmI3-7rr3J1-aytJP2-weVkj-8G16k1-VkMVw3-vAnMv-0TDyI1-7F0cA1-jrJez-a4x332-pr9";
export const IGNORE_DIRTY_CHANGES = false;
export const ANGULAR_PROD_MODE = true;
export const AUTH_MODE = "keycloak";
export const AUTH_MODE_INDEX = 0;
export const MOCK_AUTH_MODE_PREDEFINED_USERS = [];
export const V6_LEADS_ENABLED = true;
export const V6_BASE_URL = "https://gjs.gjgardner.com.au";
export const V6_COOKIE_PREFIX = "gjs_exp_prod_";
export const TODO_CHECK_ENABLED = true;
export const TODO_CHECK_INTERVAL = 300000;
export const MAINTENANCE_CHECK_ENABLED = true;
export const MAINTENANCE_CHECK_INTERVAL = 60000;
export const PRODUCE_STATUS_CHECK_INTERVAL = 10000;
export const AUTOMATION_GRID = false;
export const GOOGLE_CLIENT_ID = "141794866469-77eff3us92sg8hgt9jei9lsn4ei9v2pn.apps.googleusercontent.com";
export const GOOGLE_DEFAULT_SCOPES = "https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/cloudprint";
export const GOOGLE_UX_MODE = undefined;
export const GOOGLE_HOSTED_DOMAIN = "gjgardner.com.au";
export const GOOGLE_ANALYTICS_ID = "G-983GP00XNX";
export const SENTRY_ON = true;
export const SENTRY_DSN = "https://8508fc42643c43d3a21fc5822c016196@o509201.ingest.sentry.io/5603014";
export const SENTRY_ENVIRONMENT = "prod-au";
export const SENTRY_AUTH_TOKEN = "a434a3c180964b51b805988183eaa53adcf3216fbab34f13906b1042b504200f";
export const SENTRY_PROJECT = "builder-portal";
export const SENTRY_ORG = "softeq-hb";
export const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiZGV2ZWxvcGVyLWdqZ2FyZG5lciIsImEiOiJjbWhlaHJienUwMHFjMm5yMDY0NGs3ZXJ1In0.3rKDSD06N5HMqIIE-mS1pw";
export const HELP_URL = "https://builder-help.gjgardner.com.au/{path}";
export const DEFAULT_CURRENCY_TEMPLATE = "{sign}${number}";
export const EXPERIMENTS_DEV_MODULE = false;
export const MOCK_BACKEND_DEV_MODULE = false;
export const IE_11_DEV_MODE = false;
export const HELP_DEV_MODE = false;